module.exports = __webpack_public_path__ + "static/media/slide-2.81a8071a.jpg";